import * as React from 'react'
import PropTypes from 'prop-types'
import clsx from 'clsx'
import { createUseStyles } from 'react-jss'
import CommentBoxBase from './CommentBoxBase'

const useStyles = createUseStyles(
  {
    'comment-box-xyz': {
      display: 'inline-block'
    }
  },
  { name: 'bund-' }
)

export const CommentBox = (props) => {
  const { children, title, className, style, handleSubmit, ...rest } = props
  const classes = useStyles()
  return <CommentBoxBase />
}

CommentBox.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  style: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
  title: PropTypes.string
}

CommentBox.displayName = 'cb'

export default CommentBox
